import { usePersistedPrismicStore } from '@/store.js';

export const useFeatureFlag = (key) => {
    const featureFlags = usePersistedPrismicStore((state) => state.featureFlags);

    return !!featureFlags[key];
};
